import {
  ChangeDetectorRef,
  Component
} from '@angular/core';

import {
  SelfSchedulingDataService,
  SelfSchedulingDocumentAcquisitionService,
} from "../../../app-main/self.scheduling/services";
import {WindowRef} from "@progress/kendo-angular-dialog";
import {PopupWindowService} from "../../services/popup.window.service";
import {SystemConfigurationValues} from "../../configuration/services/system.configuration.manager";

@Component({
  selector: 'document-acquisition',
  templateUrl: './document.acquisition.component.html',
  styleUrls: ['./document.acquisition.component.scss']
})
export class DocumentAcquisitionComponent {

  isFormValid = false;
  documentsLoaded = false;

  constructor(private changeDetector: ChangeDetectorRef, public window: WindowRef,
              public selfSchedulingDocumentAcquisitionService: SelfSchedulingDocumentAcquisitionService,
              public popupWindowService: PopupWindowService, public selfSchedulingDataService: SelfSchedulingDataService,
              public cfg: SystemConfigurationValues) {
  }

  validateForm(isValid: boolean) {
    this.isFormValid = isValid;
    this.changeDetector.markForCheck();
  }

  updateDocumentLoadedState(documentsLoaded: boolean) {
    this.documentsLoaded = documentsLoaded;
  }

  cancel() {
    this.selfSchedulingDocumentAcquisitionService.restorePreviousState();
    this.popupWindowService.closePopup(this.window, 'cancel');
  }

  submit() {
    let closeArgs = '';

    if (this.documentsLoaded) {
      closeArgs = 'okDocs'
    } else {
      closeArgs = 'ok'
      this.selfSchedulingDocumentAcquisitionService.clearData();
    }

    this.popupWindowService.closePopup(this.window, closeArgs)
  }
}
